import { History, Flame } from "lucide-react";

const Stat = ({ label, value, hint }) => (
  <div className="flex flex-col gap-0.5">
    <span className="text-[10px] uppercase tracking-[0.12em] text-muted-foreground font-medium">{label}</span>
    <span className="text-sm font-tabular font-bold text-foreground">{value}</span>
    {hint && <span className="text-[10px] text-muted-foreground">{hint}</span>}
  </div>
);

export const H2HInsight = ({ h2h, homeName, awayName, compact = false }) => {
  if (!h2h || (h2h.total_meetings ?? 0) === 0) {
    return (
      <div
        className="rounded-lg border border-border bg-subtle p-3 text-xs text-muted-foreground"
        data-testid="h2h-empty"
      >
        <History className="w-3.5 h-3.5 inline mr-1.5 -mt-0.5" />
        No prior meetings recorded
      </div>
    );
  }

  const total = h2h.total_meetings || 0;
  const w1 = h2h.team1_wins || 0;
  const w2 = h2h.team2_wins || 0;
  const draws = h2h.draws || 0;
  const winPct1 = Math.round((w1 / total) * 100);
  const winPct2 = Math.round((w2 / total) * 100);
  const drawPct = 100 - winPct1 - winPct2;
  const btts = Math.round(h2h.btts_percentage || 0);
  const avgGoals = (h2h.avg_goals_per_game || 0).toFixed(1);
  const isHigh = (h2h.high_scoring_percentage || 0) >= 50;

  return (
    <div
      className="rounded-xl border border-border bg-subtle p-3.5"
      data-testid="h2h-insight"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="eyebrow flex items-center gap-1.5">
          <History className="w-3.5 h-3.5" />
          Head-to-Head · last {total}
        </div>
        {isHigh && (
          <span className="inline-flex items-center gap-1 text-[10px] text-warning font-semibold">
            <Flame className="w-3 h-3" /> High-scoring rivalry
          </span>
        )}
      </div>

      <div className="h-2 rounded-full overflow-hidden bg-muted flex mb-2.5" data-testid="h2h-bar">
        <div className="bg-success" style={{ width: `${winPct1}%` }} title={`${homeName} ${winPct1}%`} />
        <div className="bg-muted-foreground/50" style={{ width: `${drawPct}%` }} title={`Draws ${drawPct}%`} />
        <div className="bg-destructive" style={{ width: `${winPct2}%` }} title={`${awayName} ${winPct2}%`} />
      </div>
      <div className="flex justify-between text-[10px] font-medium mb-3">
        <span className="text-success">
          {homeName.length > 14 ? homeName.slice(0, 14) + "…" : homeName} {w1}W
        </span>
        <span className="text-muted-foreground">{draws}D</span>
        <span className="text-destructive">
          {w2}W {awayName.length > 14 ? awayName.slice(0, 14) + "…" : awayName}
        </span>
      </div>

      {!compact && (
        <div className="grid grid-cols-3 gap-2 pt-2 border-t border-border">
          <Stat label="BTTS" value={`${btts}%`} hint={btts >= 50 ? "Trending Yes" : "Trending No"} />
          <Stat label="Avg Goals" value={avgGoals} hint={parseFloat(avgGoals) >= 2.5 ? "Over leans" : "Under leans"} />
          <Stat
            label="Clean Sheets"
            value={`${h2h.team1_clean_sheets || 0}-${h2h.team2_clean_sheets || 0}`}
            hint="H/A"
          />
        </div>
      )}
    </div>
  );
};

export default H2HInsight;
